import { render } from "./EnbDestaques.vue?vue&type=template&id=b5de8594&scoped=true"
import script from "./EnbDestaques.vue?vue&type=script&lang=js"
export * from "./EnbDestaques.vue?vue&type=script&lang=js"

import "./EnbDestaques.vue?vue&type=style&index=0&id=b5de8594&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5de8594"]])

export default __exports__